


































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout, maskMoney } from '@/utils/common'
import { ItemTabelaPrecoProcedimento } from '@/types/_'

@Component
export default class ViewFinanceiroTabelaProrpia extends Vue {
  itemTabelaPrecoProcedimentoMode: string = 'CREATE'

  loadEditarItemTabelaPrecoProcedimento: string = ''
  get loadingEditarItemTabelaPrecoProcedimento() { return this.loadEditarItemTabelaPrecoProcedimento }
  set loadingEditarItemTabelaPrecoProcedimento(value: string) { this.loadEditarItemTabelaPrecoProcedimento = value }

  loadDeleteItemTabelaPrecoProcedimento: boolean = false
  get loadingDeleteItemTabelaPrecoProcedimento() { return this.loadDeleteItemTabelaPrecoProcedimento }
  set loadingDeleteItemTabelaPrecoProcedimento(value: boolean) { this.loadDeleteItemTabelaPrecoProcedimento = value }

  itemToDelete: string | number = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: string | number) { this.itemToDelete = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  loadSelectTabelaReferencia: boolean = false
  get loadingSelectTabelaReferencia() { return this.loadSelectTabelaReferencia }
  set loadingSelectTabelaReferencia(value: boolean) { this.loadSelectTabelaReferencia = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itemsTabelaPrecoProcedimentoTableHeader() {
    return [
      { text: 'Código único', value: 'codigoUnico', align: 'left', sortable: false },
      { text: 'Descrição', value: 'descricao', align: 'left', sortable: false },
      { text: 'Valor base', value: 'valorProcedimento', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  setItemToDelete(id: string | number) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  get itemsTabelaPrecoProcedimento() {
    return this.getFinanceiroStore.itemsTabelaPrecoProcedimento
  }

  criarItemTabelaPrecoProcedimento() {
    this.itemTabelaPrecoProcedimentoMode = 'CREATE'
    this.getFinanceiroStore.clearItemTabelaPrecoProcedimento()
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemTabelaPrecoProcedimento', value: true })
  }

  async openModalEmitirRelatorio() {
    this.getFinanceiroStore.setModal({ name: 'emitirRelatorio', value: true })
  }

  async editarItemTabelaPrecoProcedimento(item: any) {
    this.itemTabelaPrecoProcedimentoMode = 'EDIT'
    this.getFinanceiroStore.clearItemTabelaPrecoProcedimento()
    this.loadingEditarItemTabelaPrecoProcedimento = item.id
    await timeout(500)
    this.getFinanceiroStore.setItemTabelaPrecoProcedimento({ ...item } as ItemTabelaPrecoProcedimento)
    this.getFinanceiroStore.setOriginalItemTabelaPrecoProcedimento({ ...item } as ItemTabelaPrecoProcedimento)
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemTabelaPrecoProcedimento', value: true })
    this.loadingEditarItemTabelaPrecoProcedimento = ''
  }

  async apagarItemTabelaPrecoProcedimento() {
    this.loadingDeleteItemTabelaPrecoProcedimento = true
    const response = await this.getFinanceiroStore.deleteItemByTabelaDeReferenciaId(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingDeleteItemTabelaPrecoProcedimento = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.getFinanceiroStore.getTabelaPrecoAll()
    this.loadingDataTable = false
  }

  async getItemsTabelaPropria(id: string | number) {
    this.getFinanceiroStore.setItemTabelaReferenciaId(id)
    this.loadingSelectTabelaReferencia = true
    this.getFinanceiroStore.clearItemsTabelaPrecoProcedimento()
    const response = await this.getFinanceiroStore.getItensByTabelaDeReferenciaId()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || `Ocorreu um erro ao buscar resultados... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }

    this.loadingSelectTabelaReferencia = false
  }

  async init() {
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.itemsTabelaPrecoProcedimentoTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsTabelaPrecoProcedimentoPagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsTabelaPrecoProcedimentoPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getItensByTabelaDeReferenciaId()
    this.loadingDataTable = false
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  @Watch('showModalDeleteItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) this.itemToDeleteId = ''
  }

  /**
   * Filtro codigo descricao
   */


  async getAllResults() {
    this.loadingDataTable = true
    this.getPagina = 1
    await this.getFinanceiroStore.getItensByTabelaDeReferenciaId()
    this.loadingDataTable = false
  }

  codigoDebounce = _.debounce(input => this.getCodigoDebounce(input), 500)
  async searchCodigoDebounce(input) {
    this.codigoDebounce(encodeURIComponent(input))
  }

  descricaoDebounce = _.debounce(input => this.getDescricaoDebounce(input), 500)
  async searchDescricaoDebounce(input) {
    this.descricaoDebounce(encodeURIComponent(input))
  }

  async getCodigoDebounce(input: string) {
    this.getFinanceiroStore.setSearchCodigoDebounce(input)
    await this.getAllResults()
  }

  async getDescricaoDebounce(input: string) {
    this.getFinanceiroStore.setSearchDescricaoDebounce(input)
    await this.getAllResults()
  }

  get searchCodigo() {
    return this.getFinanceiroStore.searchCodigo
  }

  set searchCodigo(value: string) {
    this.getFinanceiroStore.setSearchCodigo(value)
  }

  get searchDescricao() {
    return this.getFinanceiroStore.searchDescricao
  }

  set searchDescricao(value: string) {
    this.getFinanceiroStore.setSearchDescricao(value)
  }
}
